module.exports = __webpack_public_path__ + "static/media/P8.15cf2e92.png";